import { API } from 'src/utils/interceptor'

export const addMissingProductsToShoppingList = async (
  venueId,
  missingProducts,
) => {
  const endpoint = `venue/${venueId}/add-missing-products`

  return API.post('api2', endpoint, {
    body: { missingProducts },
  })
}
